export default __webpack_public_path__ + "static/media/Mega checklist.90eb7398.xlsx";